import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../shared/TailwindComponents/Button';
import Textarea from '../../shared/TailwindComponents/Textarea';
import { useAppDispatch } from '../../../store';
import { hideModal } from '../../../store/actions/modalActions';

interface EditDraftInstructionModalProps {
  initialInstruction: string;
  onConfirm: (instruction: string) => void;
  onCancel: () => void;
}

const EditDraftInstructionModal: React.FC<EditDraftInstructionModalProps> = ({
  initialInstruction,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [instruction, setInstruction] = useState(initialInstruction);

  useEffect(() => {
    setInstruction(initialInstruction);
  }, [initialInstruction]);

  const handleSave = () => {
    onConfirm(instruction);
    dispatch(hideModal());
  };

  const handleClear = () => {
    setInstruction('');
  };

  const handleCancel = () => {
    onCancel();
    dispatch(hideModal());
  };

  return (
    <div className="min-w-[600px] sm:w-full">
      <div className='px-4'>
      <Textarea
        id="draft-instruction"
        className="w-full"
        value={instruction}
        onChange={(e) => setInstruction(e.target.value)}
        rows={6}
        placeholder={t('Enter your custom instruction here...')} label={''}      />
        </div>
      <div className="mt-6 pt-6 border-1 border-t border-gray-300 flex justify-end gap-2 px-4">
        <Button variant="neutral" size="small" onClick={handleCancel}>
          {t('Cancel')}
        </Button>
        <Button variant="outline" size="small" onClick={handleClear}>
          {t('Clear')}
        </Button>
        <Button
          variant="primary"
          size="small"
          onClick={handleSave}
          disabled={!instruction.trim()}
        >
          {t('Save')}
        </Button>
      </div>
    </div>
  );
};

export default EditDraftInstructionModal;